<template>
  <figure class="trend">
    <ins>{{ formatNumber(data[1]) }}</ins>
    <span :class="trend">
      <Icon class="icon" name=arrow />
      <template v-if="percent !== undefined">
        <span v-if="!percent">0%</span>
        <span v-if="percent < 0">{{ formatNumber(-percent) }}%</span>
        <span v-if="percent > 0">{{ formatNumber(percent) }}%</span>
      </template>
    </span>
  </figure>
</template>

<script>
  export default {
    name: 'Trend',
    props: ['data'],
    data () {return {
      //this property generates the formatting function. Weird, I know.
      formatNumber: (number) => this.$fields.entry({
        format: 'int',
      }, 'data').function({data: number}),
    }},
    computed: {
      percent () {
        var a = Number(this.data[0]);
        var b = Number(this.data[1]);
        if (a === b) {
          return 0;
        }
        if (a) {
          return (b - a) / a * 100;
        } else {
          return undefined;
        }
      },
      trend () {
        if (!Number(this.data[1]) && !Number(this.data[0])) {
          return 'empty';
        }
        switch (Math.sign(Number(this.data[1]) - Number(this.data[0]))) {
          case 1:
            return 'up';
          case -1:
            return 'down';
          default:
            return 'constant';
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  figure.trend {
    background: $body-bg;
    padding: 13px 14px;
    display: flex;
    align-items: center;
    > * {
      display: inline-block;
      width: 50%;
      flex-basis: 50%;
      text-align: center;
    }
    > ins {
      @include font-size(50px, 60px);
      text-decoration: none;
    }
    > span {
      color: white;
      padding: 7px 12px;
      @include font-size(35px, 47px);
      @media (max-width: $xs-max) {
        @include font-size(25px, 1);
      }
      font-weight: 700;
      > .icon {
        height: 47px;
        vertical-align: bottom;
      }
      > * {
        display: inline-block;
      }
    }
    > .constant {
      background: $accent;
      .icon {
        display: none;
      }
    }
    > .up {
      background: $state-success;
    }
    > .down {
      background: $state-error;
      .icon {
        transform: scaleY(-1);
      }
    }
    > .empty {
      background: white;
      color: transparent;
      user-select: none;
      .icon {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/helpers/components/charts/Trend.vue